import { addVehicle } from "action/garage/addVehicle";
import { openModal } from "action/modal/openModal";
import classNames from "classnames";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import BoxedVehicleSelector from "component/vehicle-form/BoxedVehicleSelector";
import { RootState } from "interfaces/generics.type";
import VehicleIcon from "modules/home/VehicleIcon";
import { useTranslation } from "next-i18next";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { createMakeImageSource } from "util/vehicle/createMakeImageSource";
import { createVehicleDescription } from "util/vehicle/createVehicleDescription";
import { getVehicleSelectionOrder } from "util/vehicle/get-vehicle-selection-order";
import getFocusEl from "util/vehicle/getFocusEl";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import stylesV2 from "../category-tree-v2.module.scss";
import styles from "./categoryVehicleSelector.module.scss";

interface IProps {
  defaultMake: string | null,
  defaultModel: string | null,
  defaultYear: string | null,
  showHeading?: boolean,
}
function CategoryVehicleSelector(props: IProps) {
  const {
    defaultMake, defaultModel, defaultYear,
    showHeading = true,
  } = props;
  const { t } = useTranslation("category");
  const { selectedVehicle } = useSelector((state: RootState) => state.garage);
  const { urlInformation } = useSelector((state: RootState) => state.utils);
  const { businessCustomer } = useSelector((state: RootState) => state.authenticationState);
  const vehicleDes = createVehicleDescription(selectedVehicle, businessCustomer);
  const selectionOrder = getVehicleSelectionOrder(defaultMake, defaultModel, defaultYear, businessCustomer);
  const focusElement = getFocusEl(selectionOrder, { defaultMake, defaultModel, defaultYear });
  const dispatch = useDispatch();
  const {
    tier0, tier1, tier2, tier3,
  } = urlInformation || {};
  const category = {
    tier0, tier1, tier2, tier3,
  };

  let renderVehicleSelectorFrom = (

    <div className={classNames(styles.vehicle_selector_container, stylesV2.category_vehicle_selector, {
    })}
    >
      <HideIf show={showHeading}>
        <div className={styles.vehicle_selector_text}>
          <VehicleIcon dark height={35} width={35} />

          <PAText
            className="p-l-10"
            style={{
              fontSize: "calc(1.8 * var(--safari-root-font, 10px))", margin: 0, fontWeight: "500", lineHeight: "1.1",
            }}
          >
            <strong>
              {t("Select Your Vehicle") }
            </strong>
          </PAText>
        </div>
      </HideIf>

      <BoxedVehicleSelector
        focusEl={focusElement}
        defaultMake={defaultMake}
        defaultModel={defaultModel}
        defaultYear={defaultYear}
        selectionOrder={selectionOrder}
        onSelectVehicle={(vehicle) => {
          dispatch(addVehicle(vehicle));
        }}
        category={category}
        handleFOBlur={(vehicle) => dispatch(addVehicle(vehicle))}
        newStyles={false}
      />
    </div>

  );

  if (validateVehicle(selectedVehicle)) {
    const vehicleDescription = createVehicleDescription(selectedVehicle, businessCustomer);

    renderVehicleSelectorFrom = (
      <div className={styles.vehicle_description_container}>
        <div>
          <PAImage
            alt={vehicleDes}
            src={createMakeImageSource(selectedVehicle)}
            width={40}
            height={40}
          />
        </div>
        <div>
          <PAText bold>
            {vehicleDescription}
          </PAText>
          <i
            className="fa fa-pencil-square-o"
            onClick={() => dispatch(openModal("vehicleSelector",
              { forceTrigger: true }))}
          />
        </div>

      </div>
    );
  }
  return (
    renderVehicleSelectorFrom
  );
}

export default CategoryVehicleSelector;
